module.exports = __webpack_public_path__ + "img/logo.d619f30e.png";